import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/facebook-logo.png'
import _imports_1 from '../../assets/twitter-logo.png'
import _imports_2 from '../../assets/web-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4ea3e9fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-2 footer-element" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "p-item"
}
const _hoisted_4 = {
  key: 1,
  class: "overlay"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "social-network"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "overlay"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "social-network"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "overlay"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "social-network"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "mt-2 footer-element footer__center" }
const _hoisted_17 = {
  key: 0,
  class: "material-icons icon"
}
const _hoisted_18 = {
  key: 1,
  class: "footer-title"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 3,
  class: "footer-location"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 4,
  class: "location-title"
}
const _hoisted_23 = {
  key: 0,
  class: "mt-2 footer-element"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon" }, "perm_phone_msg", -1))
const _hoisted_25 = { class: "footer-title" }
const _hoisted_26 = {
  key: 0,
  class: "contactUs-title"
}
const _hoisted_27 = {
  key: 1,
  class: "contactUs-item"
}
const _hoisted_28 = {
  key: 2,
  class: "contactUs-item"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 3,
  class: "contactUs-item"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "footer-policies-container" }
const _hoisted_35 = { class: "footer-policies-container" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://inncosys.com/",
    class: "inncosys__link"
  }, "Inncosys")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      class: "primary__color__bg footer-container",
      gutter: 20
    }, {
      default: _withCtx(() => [
        (_ctx.eventData)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              xs: 24,
              sm: 24,
              md: 8,
              lg: 8,
              xl: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("img", {
                    class: "item-center",
                    src: _ctx.eventData.themeSettings?.logoURL,
                    alt: "event photo",
                    height: "60"
                  }, null, 8, _hoisted_2),
                  (_ctx.eventData && _ctx.eventData.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.eventData.description), 1))
                    : _createCommentVNode("", true),
                  (_ctx.footer != null && _ctx.footer.facebook)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createElementVNode("a", {
                          href: _ctx.sanitizedFacebookUrl,
                          target: "_blank",
                          id: "facebookLink"
                        }, _hoisted_7, 8, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.footer != null && _ctx.footer.twitter)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createElementVNode("a", {
                          href: _ctx.sanitizedTwitterUrl,
                          target: "_blank",
                          id: "twitterLink"
                        }, _hoisted_11, 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.footer != null && _ctx.footer.web)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createElementVNode("a", {
                          href: _ctx.sanitizedWebsiteUrl,
                          target: "_blank",
                          id: "webLink"
                        }, _hoisted_15, 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 8,
          lg: 8,
          xl: 8
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              (_ctx.footer != null && _ctx.footer.eventLocation)
                ? (_openBlock(), _createElementBlock("i", _hoisted_17, "location_pin"))
                : _createCommentVNode("", true),
              (_ctx.footer != null && _ctx.footer.eventLocation)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("footer.eventLocation")), 1))
                : _createCommentVNode("", true),
              (_ctx.footer != null && _ctx.footer.eventLocationURL)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    target: "_blank",
                    href: _ctx.sanitizedLocationUrl
                  }, [
                    _createVNode(_component_el_image, {
                      src: _ctx.footer.eventLocationURL
                    }, null, 8, ["src"])
                  ], 8, _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.footer != null && _ctx.footer.eventLocation)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                    _createElementVNode("a", {
                      class: "location__link",
                      target: "_blank",
                      id: "locationLink",
                      href: _ctx.sanitizedLocationUrl
                    }, _toDisplayString(_ctx.footer.eventLocation), 9, _hoisted_21)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.footer != null && _ctx.footer.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.footer.name), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 8,
          lg: 8,
          xl: 8
        }, {
          default: _withCtx(() => [
            (_ctx.contactUsInfo != null && _ctx.contactUsInfo.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("footer.contactUs")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactUsInfo, (contact, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "contactUs-container",
                      key: index
                    }, [
                      (contact.name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(contact.name), 1))
                        : _createCommentVNode("", true),
                      (contact.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(contact.description), 1))
                        : _createCommentVNode("", true),
                      (contact.email)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("footer.email")), 1),
                            _createElementVNode("a", {
                              class: "footer__links",
                              href: 'mailto:' + contact.email
                            }, _toDisplayString(contact.email), 9, _hoisted_29)
                          ]))
                        : _createCommentVNode("", true),
                      (contact.phone)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("footer.phone")), 1),
                            _createElementVNode("a", {
                              class: "footer__links",
                              href: 'tel:' + contact.phone
                            }, _toDisplayString(contact.phone), 9, _hoisted_31)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "item-center"
        }, {
          default: _withCtx(() => [
            _hoisted_32,
            _createElementVNode("img", {
              src: _ctx.eventData.themeSettings?.logoURL,
              alt: "event photo",
              height: "60"
            }, null, 8, _hoisted_33)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 9,
          offset: 15,
          class: "footer-policies footer-policies-desktop"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              (_ctx.eventData.privacyPolicy)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('PrivacyPolicy'))),
                    class: "policy-link"
                  }, _toDisplayString(_ctx.$t("footer.privacyPolicy")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_35, [
              (_ctx.eventData.registrationCancelationPolicy)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "policy-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('RegistrationPolicies')))
                  }, _toDisplayString(_ctx.$t("footer.registrationCancellationPolicy")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_ctx.eventData.bookingCancelationPolicy)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "policy-link",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('BookingPolicies')))
                  }, _toDisplayString(_ctx.$t("footer.bookingCancellationPolicy")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 8,
          lg: 8,
          xl: 8,
          class: "text-center footer-policies-mobile"
        }, {
          default: _withCtx(() => [
            (_ctx.eventData.privacyPolicy)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('PrivacyPolicy'))),
                  class: "policy-link"
                }, _toDisplayString(_ctx.$t("footer.privacyPolicy")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 8,
          lg: 8,
          xl: 8,
          class: "text-center footer-policies-mobile"
        }, {
          default: _withCtx(() => [
            (_ctx.eventData.registrationCancelationPolicy)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "policy-link",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('RegistrationPolicies')))
                }, _toDisplayString(_ctx.$t("footer.registrationCancellationPolicy")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 8,
          lg: 8,
          xl: 8,
          class: "text-center footer-policies-mobile"
        }, {
          default: _withCtx(() => [
            (_ctx.eventData.bookingCancelationPolicy)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "policy-link",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goTo('BookingPolicies')))
                }, _toDisplayString(_ctx.$t("footer.bookingCancellationPolicy")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: _normalizeClass(["primary__color__bg footer-container", { 'footer-logged-padding': _ctx.isLogged && _ctx.type === 'sm' }]),
      gutter: 20
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "text--center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("footer.poweredBy")), 1),
              _hoisted_36
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}